import { Badge, Col, Row } from "react-bootstrap";
import ProductImage from "../category/listings/ProductImage";
import { INVENTORY_STATES, SALE_STATES } from "../../core/blocks/AdPlan/constants";
import { useTranslation } from "react-i18next";

interface ProductCardHeaderProps {
  product: {
    id?: string;
    sales_state?: string;
    stock_status?: string;
    product_title?: string;
    asin?: string;
    sku?: string;
  };
}

const SALES_STATE_ARRAY = [SALE_STATES.BEST_SELLER, SALE_STATES.CLEARANCE, SALE_STATES.NEW_PRODUCT];
const INVENTORY_STATE_ARRAY = [INVENTORY_STATES.OVERSTOCK, INVENTORY_STATES.LOW_STOCK, INVENTORY_STATES.OUT_OF_STOCK];

const ProductCardHeader: React.FC<ProductCardHeaderProps> = ({ product }) => {
  const { t } = useTranslation(["merchandising", "advertising"]);
  const productId = product.id;
  const salesLabelSelector = SALES_STATE_ARRAY.find((s) => s?.value === product.sales_state)?.label;
  const inventoryBadgeSelector = INVENTORY_STATE_ARRAY.find((s) => s?.value === product.stock_status)?.label;
  return (
    <Row>
      <Col xs={12}>
        <div style={{ display: "flex" }}>
          <div style={{ width: "120px", paddingRight: "20px" }}>
            <ProductImage id={productId} style={{ borderRadius: 15 }} width={100} height={100} />
          </div>
          <div>
            <Row>
              <Col xs={12}>
                <h3
                  style={{
                    marginBottom: "0.2rem",
                    marginTop: "0",
                    fontSize: 22,
                  }}
                >
                  {product.product_title}
                </h3>
              </Col>
              <Col xs={12}>
                {product.asin} ({product.sku})
              </Col>
              <Col xs={12}>
                {inventoryBadgeSelector && (
                  <Badge
                    className="trellis-badge bg-trellis-purple"
                    style={{
                      marginRight: "0.5rem",
                      backgroundColor: "#c43066",
                    }}
                    pill
                  >
                    {t(inventoryBadgeSelector)}
                  </Badge>
                )}
                {salesLabelSelector && (
                  <Badge className="trellis-badge bg-trellis-fuchsia" pill>
                    {t(salesLabelSelector)}
                  </Badge>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ProductCardHeader;
